import colors from '../../../styles/colors';

export const DEFAULT_MIN = 0;
export const DEFAULT_MAX = 365;
export const DEFAULT_UNIT = 'days';

export const PRIMARY_BLUE = colors.blue[600];
export const PRIMARY_BLUE_HOVER = colors.blue[700];
export const SEGMENT_BG = '#F0F2F5';

export const EDIT_BTN_STYLES = {
  size: 'xs' as const,
  height: '28px',
  px: '10px',
  w: '64px',
  bg: '#F0F2F5',
  border: '1px solid #DDE2EA',
  borderRadius: '6px',
  fontSize: '12px',
  _hover: { bg: '#E9EDF2' },
  _active: { bg: '#E3E8EF' },
  _focus: { boxShadow: 'none', outline: 'none' },
} as const;

export const NUM_INPUT_FIELD_STYLES = {
  h: '32px',
  borderColor: '#DDE2EA',
  borderRadius: '6px',
  fontSize: '14px',
  textAlign: 'center' as const,
  paddingInlineStart: '0',
  paddingInlineEnd: '0',
  _focus: { boxShadow: 'none', borderColor: '#DDE2EA' },
  _hover: { borderColor: '#DDE2EA' },
} as const;

export const TEXT_INPUT_FIELD_STYLES = {
  h: '36px',
  borderColor: '#DDE2EA',
  borderRadius: '6px',
  fontSize: '14px',
  _focus: { boxShadow: 'none', borderColor: '#DDE2EA' },
  _hover: { borderColor: '#DDE2EA' },
} as const;

export const SEGMENT_BUTTON_BASE = {
  size: 'sm',
  h: '32px',
  px: '16px',
  borderRadius: '6px',
  _focus: { boxShadow: 'none', outline: 'none' },
} as const;
